<script lang="ts">
  import { icon } from '#app/lib/icons'
  import { imgSrc } from '#app/lib/image_source'
  import { isOpenedOutside } from '#app/lib/utils'
  import type { ClickEvent } from '#app/types/declarations/svelte'
  import ItemShowModal from '#inventory/components/item_show_modal.svelte'
  import type { SerializedItemWithUserData } from '#inventory/lib/items'
  import { i18n } from '#user/lib/i18n'

  let {
    item = $bindable(),
    displayCover,
    showItemsOnMap,
  }: {
    item: SerializedItemWithUserData
    displayCover: boolean
    showItemsOnMap: (items: SerializedItemWithUserData[]) => void
  } = $props()

  const {
    pathname,
    details,
    distanceFromMainUser,
    personalizedTitle,
    user,
    image: cover,
    title,
    mainUserIsOwner,
  } = item

  const {
    username,
    picture: userPicture,
  } = user

  let showItemModal = $state(false)
  function showItem (e) {
    if (isOpenedOutside(e)) return
    showItemModal = true
    e.preventDefault()
  }

  function showItemOnMap (e: ClickEvent) {
    showItemsOnMap([ item ])
    e.stopPropagation()
  }
</script>

<div class="show-item">
  <a
    class="items-link"
    href={pathname}
    onclick={showItem}
    title={personalizedTitle}
  >
    <div class="cover-wrapper">
      {#if displayCover && cover}
        <img
          src={imgSrc(cover, 64)}
          alt={title}
          loading="lazy"
        />
      {/if}
    </div>
    <img
      src={imgSrc(userPicture, 64, 64)}
      alt={username}
      loading="lazy"
    />
    <div class="user-info">
      <p class="username">
        {username}
      </p>
      {#if distanceFromMainUser && !mainUserIsOwner}
        <p class="distance">
          {i18n('km_away', { distance: distanceFromMainUser })}
        </p>
      {/if}
    </div>
    {#if details}
      <p class="details">
        {details}
      </p>
    {/if}
  </a>
  {#if distanceFromMainUser && !mainUserIsOwner}
    <button
      class="map-button"
      onclick={showItemOnMap}
      title={i18n('Show user on map')}
    >
      {@html icon('map-marker')}
    </button>
  {/if}
</div>

<!-- eslint-disable-next-line svelte/no-unused-svelte-ignore -->
<!-- svelte-ignore ownership_invalid_binding -->
<ItemShowModal bind:item bind:showItemModal />

<style lang="scss">
  @import "general/scss/utils";
  .items-link{
    display: block;
    @include display-flex(row, center, flex-start);
    @include bg-hover(white, 10%);
    @include radius;
  }
  .show-item{
    @include display-flex(row, center, space-between);
    background-color: white;
    cursor: pointer;
    padding: 0.2em 0.5em;
  }
  .cover-wrapper{
    // Force width so that items without cover image are also aligned
    inline-size: 2.2em;
  }
  img{
    @include radius;
    margin-inline-end: 0.3em;
    flex: 0 0 auto;
    max-block-size: 2.5em;
    max-inline-size: 4em;
  }
  .user-info{
    min-inline-size: 5em;
    flex: 0 0 auto;
  }
  .details{
    max-block-size: 2.5em;
    flex: 1 0 0;
    overflow: hidden;
    line-height: 1.2em;
    margin-inline-start: 0.5em;
  }
  .distance{
    color: $grey;
  }
  .map-button{
    @include tiny-button($light-grey, black);
    padding: 0.5em;
    margin-inline-end: 0.2em;
  }
</style>
